// extracted by mini-css-extract-plugin
export default {"homeTablesWrap":"styles_homeTablesWrap__L1nPL","homeTablesNavigation":"styles_homeTablesNavigation__cX11r","homeTablesBody":"styles_homeTablesBody__EO7eB"};